module.exports = __webpack_public_path__ + "static/media/more.6d58726e.svg";